var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 24,
    viewBox: "0 0 40 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M22.02379,23.1197c-1.05634,1.12792-2.81935,1.17869-3.93778,.11339-.03854-.03671-.07603-.07452-.11243-.11339L.75879,4.73631C-.29657,3.60745-.24469,1.82954,.87467,.76522,1.39116,.27414,2.07405,.00043,2.7839,0H37.21348c1.53842-.00053,2.78599,1.25676,2.78652,2.80823,.00024,.71812-.27222,1.40906-.76141,1.93088L22.02379,23.1197Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.f44fbc5be05e020aee5b2492d0ac9ffc.svg";
export { ForwardRef as ReactComponent };